import { useContext } from 'react';
import { GrowthBookContext } from '@growthbook/growthbook-react';

/**
 * Whether flag values can be trusted yet.
 *
 * Read this through `useGrowthBookFlag`, which returns it alongside the flag —
 * the two are needed together, and pairing them is what stops the gate being
 * forgotten. Use it directly only where there is no single flag to read.
 *
 * `ready` turns true on success, on network failure, and on timeout — the SDK
 * applies an empty payload either way — so gating on it cannot hang. It is
 * reactive because the provider re-renders this subtree when features land, and
 * defaults to true with no provider mounted so isolated components aren't
 * blocked.
 *
 * This means the flag payload has arrived, not that targeting attributes have.
 * `useSyncGrowthBookAttributes` runs further down the tree, so a flag whose rule
 * targets tenant or realm can still evaluate once against no attributes and
 * change afterwards.
 */
export const useGrowthBookFeaturesReady = (): boolean => {
  const { growthbook } = useContext(GrowthBookContext);

  return growthbook?.ready ?? true;
};
